import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  resetpassword: FormGroup;
  sent_email: string;
  token: string;
  today = new Date();
  passwordFieldType: string = 'password';
  confirmPasswordFieldType: string = 'password';
  email: string;
  spinner: boolean = false;

  constructor(
    public ApiService: ApiServiceService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe
  ) {
    this.resetpassword = this.fb.group({
      email: [this.email],
      password: ['', [Validators.required, this.passwordValidator()]],
      cpassword: ['', [Validators.required, this.passwordValidator()]],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'] || null;
      this.token = params['token'] || null;
  
      if (!this.email && !this.token) {
        Swal.fire({
          title: "Error",
          text: "Email not found.",
          icon: "error",
          confirmButtonText: "Okay",
          iconColor: "#FF0000"
        });
      }
    });

  }
  postdata(forgotForm: any) {
    this.spinnerService.show();
    this.spinner=true;

    if (forgotForm.value.password == forgotForm.value.cpassword) {
      if (forgotForm.value.password !== '' && forgotForm.value.cpassword !== '') {
        
        this.ApiService.resetpassword(this.email, forgotForm.value.password, forgotForm.value.cpassword)
          .subscribe(
            data => {
              this.spinnerService.hide();
              this.spinner=false;
    
              Swal.fire({
                title: "Password has been updated",
                icon: "success",
                confirmButtonText: "Okay",
                iconColor: "#015792" 
              }).then(() => {
                this.resetpassword.reset();
                this.router.navigate(['']);
              });
            },
            error => {
        
              Swal.fire({
                title: "Error updating password",
                icon: "error",
                confirmButtonText: "Okay",
                iconColor: "#FF0000" 
              });
            }
          );
      } else {
        Swal.fire({
          title: "Please enter password",
          icon: "error",
          confirmButtonText: "Okay",
          iconColor: "#FF0000" 
        });
      }
    } else {
      Swal.fire({
        title: "Password and confirm password not same",
        icon: "error",
        confirmButtonText: "Okay",
        iconColor: "#FF0000" 
      }).then(() => {
        window.location.reload();
      });
    }

  }
  // get email() { return this.resetpassword.get('email'); }
  get password() { return this.resetpassword.get('password'); }
  get cpassword() { return this.resetpassword.get('cpassword'); }


  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.value;

      if (!password) {
        return null; 
      }

      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      const hasMinLength = password.length >= 8;

      const passwordValid = hasUpperCase && hasLowerCase && hasSpecialChar && hasMinLength;

      return !passwordValid ? { passwordStrength: true } : null;
    };
  }

  togglePasswordVisibility(): void {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  toggleConfirmPasswordVisibility(): void {
    this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
  }

}